import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=9645230c&scoped=true&"
import script from "./CardBody.vue?vue&type=script&lang=js&"
export * from "./CardBody.vue?vue&type=script&lang=js&"
import style0 from "./CardBody.vue?vue&type=style&index=0&id=9645230c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9645230c",
  null
  
)

export default component.exports